import {FrontendFiltersOrderSearch} from "./FrontendFiltersOrderSearch";
import {FrontendFilterValues} from "@/components/FrontendFilters/structs";

export class FrontendFiltersRequiresNextActionDecisionSearch extends FrontendFiltersOrderSearch {
    subIdentifier = 'requires-next-action-decision';

    pageTitleLanguageKey = `frontend-filters.page-titles.orders`;
    pageIcon = 'pe-7s-search';

    getResultLink(result: Record<string,string>, filterValues: FrontendFilterValues): Record<string,any> {
        return {
            name: 'OrderNextActionDecision',
            params: {
                salesOrderIdentifier: result.order_identifier,
            },
        }
    };
}

